import { render, staticRenderFns } from "./TotalOrdersChart.vue?vue&type=template&id=03876b99&scoped=true&"
import script from "./TotalOrdersChart.vue?vue&type=script&lang=js&"
export * from "./TotalOrdersChart.vue?vue&type=script&lang=js&"
import style0 from "./TotalOrdersChart.vue?vue&type=style&index=0&id=03876b99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03876b99",
  null
  
)

export default component.exports